import { useEffect, useState } from "react";
import { Button } from "react-aria-components";
import { IPicklistItem } from "../List/DisposalsPickList";
import LoadingButton from "../LoadingButton";
import { movingSidePanelSignal } from "../layout/Layout";
import { useSignals } from "@preact/signals-react/runtime";
import { IDisposalCheck } from "../layout/SidePanel/layouts/SidePanelDisposalPickList";

interface IPickingButtonProps {
    lineItems: IPicklistItem[];
    save: Function;
    submit: Function;
    cancel?: Function;
    minimumDisposalCheckCount: number,
    currentDisposalChecks: IDisposalCheck[]
}

export default function DisposalPickingButtons({ lineItems, save, submit, cancel, minimumDisposalCheckCount, currentDisposalChecks }: IPickingButtonProps) {
    useSignals()
    const [submitting, setSubmitting] = useState<boolean>(false);
    const [saving, setSaving] = useState<boolean>(false);

    async function handleSave() {
        setSaving(true);
        await save();
        setSaving(false);
    }

    async function handleSubmission(func: Function) {
        setSubmitting(true);
        await func();
        setSubmitting(false);
    }

    function uncheckedBoxCount(data: IPicklistItem[]) {
        return data.filter((x: IPicklistItem) => x.hasBeenChecked === false)?.length ?? 0;
    }

    function canSaveAndSubmit() {
        const hasUncheckedBoxes = uncheckedBoxCount(lineItems);
        const needsDisposalChecks = currentDisposalChecks.length < minimumDisposalCheckCount;
        return !hasUncheckedBoxes && !needsDisposalChecks;
    }

    return (
        <div className="margin__top--auto">
            <div>
                {!canSaveAndSubmit() && (
                    <div className="form__inline-error margin__top--xs margin__bottom--xs">
                        <p className="">All boxes must be verified - {uncheckedBoxCount(lineItems)} remaining.</p>
                        <p className="">At least {minimumDisposalCheckCount} disposal checks required - {Math.max(0, minimumDisposalCheckCount - currentDisposalChecks.length)} remaining.</p>
                    </div>
                )}
            </div>
            <div className='pick-list__picking-buttons'>
                {cancel ? (
                    <Button
                        type="button"
                        className="button button--secondary button--secondary--destructive button--small"
                        onPress={() => handleSubmission(cancel)}
                        isDisabled={submitting}
                    >
                        <p className="button-text">Cancel Disposal</p>
                    </Button>
                ) : (
                    <div className="display--flex gap--xs">
                    </div>
                )}
                <div className="display--flex gap--xs">
                    <LoadingButton
                        className="button button--secondary button--small"
                        onPress={() => handleSave()}
                        isDisabled={saving || submitting}
                        isLoading={saving}
                        buttonText="Save"
                        loadingText="Saving"
                    >
                        <></>
                    </LoadingButton>
                    <Button
                        className="button button--primary button--small"
                        onPress={() => handleSubmission(submit)}
                        isDisabled={saving || submitting || !canSaveAndSubmit()}
                    >
                        <p className="button-text">Save & Submit</p>
                    </Button>
                </div>
            </div>
        </div>
    );
}